import { Link } from 'react-router-dom';
import { cn } from '@/lib/format';

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  className?: string;
}

export default function Breadcrumb({ items, className }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑" className={cn('flex items-center flex-wrap gap-2 text-sm text-foreground-500', className)}>
      {items.map((item, index) => (
        <span key={`${item.label}-${index}`} className="flex items-center gap-2">
          {index > 0 && <i className="ri-arrow-right-s-line text-foreground-300" />}
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-700 transition-colors cursor-pointer">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-900 font-bold">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}